(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["boo-withdrawal-draggable"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.jkBooWithdrawalDragInitialized) return;
    window.jkBooWithdrawalDragInitialized = true;

    const BUTTON_SELECTOR = '.bew-btn';
    const DRAGGABLE_CLASS = 'jk-bew-draggable';
    const DRAGGING_CLASS = 'jk-bew-is-dragging';
    const POSITIONED_ATTRIBUTE = 'data-jk-bew-positioned';
    const STORAGE_KEY = 'jahikala:boo-withdrawal-position:v1';
    const MOBILE_BREAKPOINT = 768;
    const EDGE_GAP = 8;
    const DRAG_THRESHOLD = 8;
    const MANAGED_PROPERTIES = ['position', 'left', 'top', 'right', 'bottom', 'transform'];
    const trackedButtons = new Set();
    const originalStyles = new WeakMap();

    const clamp = (value, minimum, maximum) => Math.min(Math.max(value, minimum), maximum);
    const getMode = () => (window.innerWidth <= MOBILE_BREAKPOINT ? 'mobile' : 'desktop');

    const readPositions = () => {
      try {
        const positions = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
        return positions && typeof positions === 'object' ? positions : {};
      } catch (error) {
        return {};
      }
    };

    const getSavedPosition = () => {
      const position = readPositions()[getMode()];

      if (
        !position ||
        !Number.isFinite(position.x) ||
        !Number.isFinite(position.y)
      ) {
        return null;
      }

      return {
        x: clamp(position.x, 0, 1),
        y: clamp(position.y, 0, 1),
      };
    };

    const getMobileBarReserve = () => {
      if (getMode() !== 'mobile') return 0;

      const rootStyles = window.getComputedStyle(document.documentElement);
      const configuredMobileBarHeight = parseFloat(rootStyles.getPropertyValue('--mobile-sticky-bar-height')) || 0;
      const stickyAtcHeight = parseFloat(rootStyles.getPropertyValue('--sticky-atc-bar-height')) || 0;
      const mobileBar = document.querySelector('mobile-sticky-bar.mobile-sticky-bar');
      const renderedMobileBarHeight = mobileBar ? mobileBar.offsetHeight : 0;

      return Math.max(configuredMobileBarHeight, renderedMobileBarHeight) + stickyAtcHeight;
    };

    const getBounds = (button) => {
      const buttonRect = button.getBoundingClientRect();
      const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
      const viewportHeight = window.innerHeight;
      const availableBottom = viewportHeight - getMobileBarReserve() - EDGE_GAP;

      return {
        minimumLeft: EDGE_GAP,
        minimumTop: EDGE_GAP,
        maximumLeft: Math.max(EDGE_GAP, viewportWidth - buttonRect.width - EDGE_GAP),
        maximumTop: Math.max(EDGE_GAP, availableBottom - buttonRect.height),
      };
    };

    const setPosition = (button, left, top) => {
      const bounds = getBounds(button);
      const safeLeft = clamp(left, bounds.minimumLeft, bounds.maximumLeft);
      const safeTop = clamp(top, bounds.minimumTop, bounds.maximumTop);

      button.style.setProperty('position', 'fixed', 'important');
      button.style.setProperty('left', `${Math.round(safeLeft)}px`, 'important');
      button.style.setProperty('top', `${Math.round(safeTop)}px`, 'important');
      button.style.setProperty('right', 'auto', 'important');
      button.style.setProperty('bottom', 'auto', 'important');
      button.style.setProperty('transform', 'none', 'important');
      button.setAttribute(POSITIONED_ATTRIBUTE, 'true');
    };

    const clearManagedPosition = (button) => {
      if (!button.hasAttribute(POSITIONED_ATTRIBUTE)) return;

      const styles = originalStyles.get(button) || {};

      MANAGED_PROPERTIES.forEach((property) => {
        const original = styles[property];

        if (original && original.value) {
          button.style.setProperty(property, original.value, original.priority);
        } else {
          button.style.removeProperty(property);
        }
      });

      button.removeAttribute(POSITIONED_ATTRIBUTE);
    };

    const applySavedPosition = (button) => {
      const savedPosition = getSavedPosition();

      if (!savedPosition) {
        clearManagedPosition(button);
        return;
      }

      const bounds = getBounds(button);
      const horizontalRange = bounds.maximumLeft - bounds.minimumLeft;
      const verticalRange = bounds.maximumTop - bounds.minimumTop;

      setPosition(
        button,
        bounds.minimumLeft + horizontalRange * savedPosition.x,
        bounds.minimumTop + verticalRange * savedPosition.y
      );
    };

    const savePosition = (button) => {
      const buttonRect = button.getBoundingClientRect();
      const bounds = getBounds(button);
      const horizontalRange = bounds.maximumLeft - bounds.minimumLeft;
      const verticalRange = bounds.maximumTop - bounds.minimumTop;
      const positions = readPositions();

      positions[getMode()] = {
        x: horizontalRange > 0 ? clamp((buttonRect.left - bounds.minimumLeft) / horizontalRange, 0, 1) : 0,
        y: verticalRange > 0 ? clamp((buttonRect.top - bounds.minimumTop) / verticalRange, 0, 1) : 0,
      };

      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(positions));
      } catch (error) {
        // The button remains draggable when browser storage is unavailable.
      }
    };

    const rememberOriginalStyles = (button) => {
      const styles = {};

      MANAGED_PROPERTIES.forEach((property) => {
        styles[property] = {
          value: button.style.getPropertyValue(property),
          priority: button.style.getPropertyPriority(property),
        };
      });

      originalStyles.set(button, styles);
    };

    const compactButton = (button) => {
      const template = document.getElementById('jk-bew-button-content');
      if (!(template instanceof HTMLTemplateElement)) return;

      const label = button.textContent.trim();
      if (!label) return;

      const content = template.content.cloneNode(true);
      content.querySelector('.jk-bew-label').textContent = label;
      button.replaceChildren(content);
      button.classList.add('jk-bew-compact');
    };

    const attachDragging = (button) => {
      if (button.classList.contains(DRAGGABLE_CLASS)) return;

      compactButton(button);
      rememberOriginalStyles(button);
      button.classList.add(DRAGGABLE_CLASS);
      trackedButtons.add(button);

      let dragState = null;
      let suppressClick = false;
      let suppressClickTimer = null;

      button.addEventListener('pointerdown', (event) => {
        if (event.isPrimary === false || (event.pointerType === 'mouse' && event.button !== 0)) return;

        suppressClick = false;
        window.clearTimeout(suppressClickTimer);
        event.preventDefault();
        button.focus({ preventScroll: true });

        const buttonRect = button.getBoundingClientRect();
        dragState = {
          pointerId: event.pointerId,
          startX: event.clientX,
          startY: event.clientY,
          startLeft: buttonRect.left,
          startTop: buttonRect.top,
          dragging: false,
        };

        try {
          button.setPointerCapture(event.pointerId);
        } catch (error) {
          // Pointer capture is an enhancement; dragging still works without it.
        }
      });

      button.addEventListener('pointermove', (event) => {
        if (!dragState || event.pointerId !== dragState.pointerId) return;

        const movementX = event.clientX - dragState.startX;
        const movementY = event.clientY - dragState.startY;

        if (!dragState.dragging && Math.hypot(movementX, movementY) < DRAG_THRESHOLD) return;

        if (!dragState.dragging) {
          dragState.dragging = true;
          button.classList.add(DRAGGING_CLASS);
        }

        event.preventDefault();
        setPosition(button, dragState.startLeft + movementX, dragState.startTop + movementY);
      });

      const finishDragging = (event, shouldSuppressClick) => {
        if (!dragState || event.pointerId !== dragState.pointerId) return;

        if (dragState.dragging) {
          savePosition(button);

          if (shouldSuppressClick) {
            suppressClick = true;
            window.clearTimeout(suppressClickTimer);
            suppressClickTimer = window.setTimeout(() => {
              suppressClick = false;
            }, 500);
          }
        }

        button.classList.remove(DRAGGING_CLASS);

        try {
          button.releasePointerCapture(event.pointerId);
        } catch (error) {
          // The pointer may already have been released by the browser.
        }

        dragState = null;
      };

      button.addEventListener('pointerup', (event) => finishDragging(event, true));
      button.addEventListener('pointercancel', (event) => finishDragging(event, false));
      button.addEventListener('dragstart', (event) => event.preventDefault());

      button.addEventListener(
        'click',
        (event) => {
          if (!suppressClick || event.detail === 0) return;

          suppressClick = false;
          window.clearTimeout(suppressClickTimer);
          event.preventDefault();
          event.stopImmediatePropagation();
        },
        true
      );

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => applySavedPosition(button));
      });
    };

    const inspectNode = (node) => {
      if (!(node instanceof Element)) return;

      if (node.matches(BUTTON_SELECTOR)) attachDragging(node);
      node.querySelectorAll(BUTTON_SELECTOR).forEach(attachDragging);
    };

    const inspectDocument = () => {
      document.querySelectorAll(BUTTON_SELECTOR).forEach(attachDragging);
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach(inspectNode));
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', inspectDocument, { once: true });
    } else {
      inspectDocument();
    }

    let resizeFrame = null;
    window.addEventListener(
      'resize',
      () => {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(() => {
          trackedButtons.forEach((button) => {
            if (!button.isConnected) {
              trackedButtons.delete(button);
              return;
            }

            if (!button.classList.contains(DRAGGING_CLASS)) applySavedPosition(button);
          });
        });
      },
      { passive: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fishing-kit-advisor"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fishing-kit-advisor')) {
    customElements.define('fishing-kit-advisor', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        try {
          this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
          this.kitVariants = JSON.parse(this.querySelector('[data-kit-variants]').textContent);
          this.form = document.getElementById(this.dataset.formId);
          this.fish = this.querySelector('[data-fish]');
          this.water = this.querySelector('[data-water]');
          this.basket = this.querySelector('[data-basket]');
          this.ownKit = this.querySelector('[data-own-kit]');
          this.button = this.querySelector('[data-submit]');
          this.status = this.querySelector('[data-status]');
          this.cards = [...this.querySelectorAll('[data-rule]')].sort((a, b) => Number(a.dataset.priority) - Number(b.dataset.priority));
          this.cards.forEach(card => this.querySelector('[data-results]').append(card));
          this.root = window.Shopify?.routes?.root || '/';
          this.cart = { items: [] };
          this.pendingKey = 'jk-advisor-pending:' + this.dataset.productId;
          const allowed = [...this.fish.options].map(option => option.value).filter(Boolean);
          const carried = (new URLSearchParams(location.search).get('jk_fish') || '').split(',').filter(value => allowed.includes(value));
          if (carried.length === 1) this.fish.value = carried[0];
          else if (allowed.length === 1) this.fish.value = allowed[0];
          const waters = [...this.water.options].map(option => option.value).filter(Boolean);
          if (waters.length === 1) this.water.value = waters[0];
          this.addEventListener('change', event => {
            if (event.target.matches('[data-fish], [data-water], [data-basket]')) {
              this.cards.forEach(card => { card.querySelector('[data-add]').checked = false; });
              this.filter();
            } else this.refresh();
          });
          this.form?.addEventListener('change', () => this.refresh());
          this.form?.addEventListener('input', () => this.refresh());
          this.button.addEventListener('click', () => this.add());
          this.cartListener = () => this.readCart().then(() => this.refresh()).catch(() => {});
          this.cartUpdatedListener = event => {
            if (event.detail?.cart?.items) { this.cart = event.detail.cart; this.refresh(); }
          };
          document.addEventListener('product-ajax:added', this.cartListener);
          document.addEventListener('cart:refresh', this.cartListener);
          document.addEventListener('cart:updated', this.cartUpdatedListener);
          this.filter();
          this.hidden = false;
          const pending = this.readPending();
          if (pending) { this.uncertain = true; this.message(this.copy.uncertain, true); this.refresh(); }
          this.readCart().then(() => {
            if (pending && pending.ids.every(id => this.cart.items.some(line => line.variant_id === id && line.properties?._jk_advisor_request === pending.request))) {
              this.uncertain = false;
              this.savePending(null);
              this.message(this.copy.added, true);
            }
            this.refresh();
          }).catch(() => {});
        } catch (error) { this.hidden = true; }
      }
      disconnectedCallback() {
        document.removeEventListener('product-ajax:added', this.cartListener);
        document.removeEventListener('cart:refresh', this.cartListener);
        document.removeEventListener('cart:updated', this.cartUpdatedListener);
      }
      method() {
        if (this.dataset.profile === 'feeder') return this.basket?.checked ? 'feeder' : 'bottom';
        if (this.dataset.profile === 'kids') return 'float';
        if (this.dataset.profile === 'lures') return 'spinning';
        return this.dataset.profile;
      }
      filter() {
        const method = this.method();
        let visible = 0;
        this.cards.forEach(card => {
          const match = card.dataset.fish.split(',').includes(this.fish.value) && card.dataset.waters.split(',').includes(this.water.value) && card.dataset.methods.split(',').includes(method);
          card.hidden = !match || visible >= 3;
          if (!card.hidden) visible++;
        });
        const chosen = Boolean(this.fish.value && this.water.value);
        this.querySelector('[data-prompt]').hidden = chosen;
        this.querySelector('[data-empty]').hidden = !chosen || visible > 0;
        this.querySelector('[data-footer]').hidden = !visible;
        if (this.basket) {
          this.querySelector('[data-basket-note]').hidden = !this.basket.checked;
          this.querySelector('[data-bottom-note]').hidden = this.basket.checked;
        }
        const deepNote = this.querySelector('[data-deep-note]');
        if (deepNote) deepNote.hidden = this.water.value !== 'deep';
        this.message('');
        this.refresh();
        if (chosen) this.track('recommendations_viewed', { count: visible });
      }
      money(cents) {
        return new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:this.dataset.currency}).format(cents / 100);
      }
      kit() {
        const variantId = this.form?.querySelector('[name=id]')?.value;
        return this.kitVariants.find(variant => String(variant.id) === String(variantId));
      }
      quantity() {
        const value = Number(this.form?.querySelector('[name=quantity]')?.value || 1);
        return Number.isInteger(value) && value > 0 ? value : 0;
      }
      selected() {
        return this.cards.filter(card => !card.hidden && card.querySelector('[data-add]').checked && !card.querySelector('[data-add]').disabled)
          .map(card => card.querySelector('[data-variant]').selectedOptions[0]);
      }
      inCart(id) { return this.cart.items.some(item => String(item.variant_id) === String(id)); }
      refresh() {
        const kit = this.kit();
        const alreadyKit = kit && this.inCart(kit.id);
        if (alreadyKit) { this.ownKit.checked = true; this.autoOwn = true; }
        else if (this.autoOwn) { this.ownKit.checked = false; this.autoOwn = false; }
        this.ownKit.disabled = Boolean(alreadyKit);
        this.querySelector('[data-own-label]').textContent = alreadyKit ? this.copy.kit_in_cart : this.copy.own_kit;
        this.cards.forEach(card => {
          const option = card.querySelector('[data-variant]').selectedOptions[0];
          const checkbox = card.querySelector('[data-add]');
          const exists = this.inCart(option.value);
          checkbox.disabled = exists;
          if (exists || card.hidden) checkbox.checked = false;
          card.querySelector('[data-add-label]').textContent = exists ? this.copy.in_cart : this.copy.add_one;
          card.querySelector('[data-price-label]').textContent = this.money(Number(option.dataset.price));
          card.querySelectorAll('[data-product-link]').forEach(link => { link.href = option.dataset.url; });
        });
        const chosen = this.selected();
        const quantity = this.quantity();
        const kitPrice = this.ownKit.checked ? 0 : (kit?.price || 0) * quantity;
        this.querySelector('[data-total]').textContent = this.money(kitPrice + chosen.reduce((sum, option) => sum + Number(option.dataset.price), 0));
        this.querySelector('[data-summary]').textContent = this.ownKit.checked ? this.copy.addons_total : this.copy.bundle_total.replace('[quantity]', quantity);
        this.button.textContent = this.busy ? this.copy.adding : this.ownKit.checked ? this.copy.add_addons : this.copy.add_bundle;
        this.button.disabled = this.busy || this.uncertain || !chosen.length || (!this.ownKit.checked && (!kit?.available || !quantity));
      }
      async json(url, options) {
        const response = await fetch(url, {headers:{Accept:'application/json'}, ...options});
        const data = await response.json();
        if (!response.ok || data.status >= 400) throw new Error(data.description || this.copy.error);
        return data;
      }
      async readCart() {
        this.cart = await this.json(this.root + 'cart.js');
        return this.cart;
      }
      readPending() {
        try { return JSON.parse(sessionStorage.getItem(this.pendingKey)); } catch { return null; }
      }
      savePending(value) {
        try { if (value) sessionStorage.setItem(this.pendingKey, JSON.stringify(value)); else sessionStorage.removeItem(this.pendingKey); } catch { /* Cart reconciliation also works without storage. */ }
      }
      message(text, cartLink = false) {
        this.status.textContent = text;
        this.querySelector('[data-cart-link]').hidden = !cartLink;
      }
      async add() {
        if (this.busy || this.uncertain || this.button.disabled) return;
        this.busy = true;
        const desired = this.selected().map(option => ({id:Number(option.value),quantity:1,url:option.dataset.productUrl,price:Number(option.dataset.price)}));
        const kit = this.kit();
        const quantity = this.quantity();
        const includeKit = !this.ownKit.checked;
        this.refresh();
        this.inert = true;
        this.setAttribute('aria-busy', 'true');
        this.message('');
        let attempted = false;
        let confirmedRejection = false;
        let request;
        let items = [];
        try {
          await this.readCart();
          const selected = desired.filter(item => !this.inCart(item.id));
          if (includeKit && kit && !this.inCart(kit.id)) selected.unshift({id:kit.id,quantity,url:this.dataset.kitUrl,price:kit.price});
          if (!selected.length) { this.message(this.copy.already_in_cart, true); return; }
          // Verify exact current variants and prices before any cart mutation.
          for (const item of selected) {
            const current = await this.json(item.url.split('?')[0] + '?view=jk-fishing-stock', {headers:{Accept:'text/html'}});
            const variant = current.variants?.find(value => value.id === item.id);
            if (current.currency !== this.dataset.currency || !variant?.available || variant.stock < item.quantity || variant.price !== item.price) throw new Error(this.copy.changed);
          }
          request = crypto.randomUUID();
          items = selected.map(({id,quantity}) => ({id,quantity,properties:{
            _jk_advisor:'v1', _jk_advisor_request:request, _jk_advisor_kit:String(this.dataset.productId),
            _jk_advisor_fish:this.fish.value, _jk_advisor_water:this.water.value,
            _jk_advisor_method:this.method()
          }}));
          const sections = [];
          document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections',{bubbles:true,detail:{sections}}));
          this.savePending({request,ids:items.map(item => item.id)});
          attempted = true;
          const response = await fetch(this.root + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections:sections.slice(0,5),sections_url:location.pathname})});
          const result = await response.json();
          confirmedRejection = !response.ok || result.status >= 400;
          if (confirmedRejection) throw new Error(this.copy.changed);
          await this.readCart();
          if (!items.every(item => this.cart.items.some(line => line.variant_id === item.id && line.properties?._jk_advisor_request === request && line.quantity >= item.quantity))) throw new Error(this.copy.uncertain);
          this.savePending(null);
          this.success(result, items);
        } catch (error) {
          if (attempted) {
            try {
              await this.readCart();
              const matched = items.filter(item => this.cart.items.some(line => line.variant_id === item.id && line.properties?._jk_advisor_request === request && line.quantity >= item.quantity));
              if (matched.length === items.length) { this.savePending(null); this.success(null, items); return; }
              if (confirmedRejection) {
                this.savePending(null);
                this.message(matched.length ? this.copy.partial : this.copy.changed, matched.length > 0);
                document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:false}}));
              } else { this.uncertain = true; this.message(this.copy.uncertain, true); }
            } catch { this.uncertain = true; this.message(this.copy.uncertain, true); }
          } else this.message(error.message === this.copy.changed ? this.copy.changed : this.copy.error);
        } finally {
          this.busy = false;
          this.inert = false;
          this.removeAttribute('aria-busy');
          this.refresh();
        }
      }
      success(result, items) {
        this.cards.forEach(card => { card.querySelector('[data-add]').checked = false; });
        this.message(this.copy.added, true);
        this.track('added', {variant_ids:items.map(item => item.id),count:items.length});
        if (result?.sections && window.FoxTheme?.pubsub) {
          this.cart.sections = result.sections;
          window.FoxTheme.pubsub.publish(window.FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,{cart:this.cart});
          const drawer = document.querySelector('cart-drawer');
          if (drawer) drawer.show(this.button);
        } else document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{open:true}}));
        document.dispatchEvent(new CustomEvent('product-ajax:added',{detail:{product:result || {items},source:'fishing-advisor'}}));
      }
      track(action, details) {
        // Consent-gated hooks; completed orders retain private line attribution separately.
        if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
        const data = {event:'jk_fishing_advisor_' + action,kit_id:this.dataset.productId,fish:this.fish.value,water:this.water.value,...details};
        window.dataLayer?.push(data);
        window.Shopify?.analytics?.publish?.(data.event, data);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["jk-gift-card-builder"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jk-gift-card')) {
    class JkGiftCard extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.amount = this.querySelector('[data-gift-amount]');
        this.button = this.querySelector('[type="submit"]');
        this.message = this.form.elements.namedItem('properties[Message]');
        this.copy = JSON.parse(this.querySelector('[data-gift-copy]').textContent);
        this.options = JSON.parse(this.querySelector('[data-gift-options]').textContent);
        this.preview = this.dataset.preview === 'true';
        this.minimum = Number(this.dataset.minimum);
        this.maximum = Number(this.dataset.maximum);
        this.money = new Intl.NumberFormat(this.dataset.locale, { style:'currency', currency:'EUR', maximumFractionDigits:0 });
        this.form.elements.namedItem('properties[__shopify_offset]').value = new Date().getTimezoneOffset();
        this.form.addEventListener('submit', event => this.submit(event));
        this.form.addEventListener('input', () => {
          this.validateAmount(false);
          this.querySelector('[data-message-count]').textContent = this.message.value.length;
          this.querySelector('[data-review]').hidden = true;
          this.querySelector('[data-submit-error]').hidden = true;
          if (!this.busy) this.button.disabled = false;
        });
        this.amount.addEventListener('blur', () => this.validateAmount(true));
        this.form.addEventListener('change', () => this.updateDelivery());
        this.updateDelivery();
        this.validateAmount(false);
        this.button.disabled = false;
      }

      updateDelivery() {
        const self = this.form.elements.namedItem('gift_delivery').value === 'self';
        this.querySelector('[data-email-label]').textContent = this.copy[self ? 'self_email' : 'recipient_email'];
        this.querySelector('[data-delivery-hint]').textContent = this.copy[self ? 'self_hint' : 'recipient_hint'];
      }

      validateAmount(show) {
        const raw = this.amount.value.trim();
        const amount = Number(raw);
        let error = '';
        if (!raw) error = this.copy.required;
        else if (!/^\d+$/.test(raw) || !Number.isSafeInteger(amount)) error = this.copy.whole;
        else if (amount < this.minimum) error = this.copy.minimum;
        else if (amount > this.maximum) error = this.copy.maximum;
        this.amount.setCustomValidity(error);
        this.amount.setAttribute('aria-invalid', error && (raw || show) ? 'true' : 'false');
        const errorNode = this.querySelector('[data-amount-error]');
        errorNode.hidden = !error || !show;
        errorNode.textContent = show ? error : '';
        this.querySelector('[data-amount-summary]').textContent = error ? '—' : this.money.format(amount);
        return error ? null : amount;
      }

      error(message) {
        const element = this.querySelector('[data-submit-error]');
        element.textContent = message;
        element.hidden = false;
      }

      async fetchJson(url, options = {}) {
        const response = await fetch(url, { ...options, headers:{ 'Accept':'application/json', ...options.headers }, cache:'no-store', signal:AbortSignal.timeout(15000) });
        if (!response.ok) {
          let detail;
          try { detail = await response.json(); } catch (_) { detail = null; }
          throw new Error(detail && typeof detail.description === 'string' ? detail.description : this.copy.network);
        }
        return response.json();
      }

      async submit(event) {
        event.preventDefault();
        if (this.busy) return;
        const amount = this.validateAmount(true);
        if (amount === null || !this.form.reportValidity()) return;
        if (this.dataset.currency !== 'EUR') { this.error(this.copy.currency); return; }
        if (this.preview) {
          const panel = this.querySelector('[data-review]');
          this.querySelector('[data-review-amount]').textContent = this.money.format(amount);
          this.querySelector('[data-review-email]').textContent = this.form.elements.namedItem('properties[Recipient email]').value;
          this.querySelector('[data-review-name]').textContent = this.form.elements.namedItem('properties[Recipient name]').value;
          this.querySelector('[data-review-message]').textContent = this.message.value;
          this.querySelector('[data-review-message]').hidden = !this.message.value;
          panel.hidden = false;
          panel.focus({ preventScroll:true });
          panel.scrollIntoView({ behavior:'smooth', block:'nearest' });
          return;
        }
        this.busy = true;
        this.form.inert = true;
        this.button.disabled = true;
        this.querySelector('[data-submit-error]').hidden = true;
        const initialButtonText = this.button.querySelector('span').textContent;
        let requestAttempted = false;
        let storageKey;
        try {
          const matches = this.options.filter(option => Number(String(option.name).replace(/[€\s]/g, '').replace(',', '.')) === amount);
          if (matches.length !== 1) throw new Error(this.copy.unavailable);
          const lookup = new URL(this.dataset.productUrl, location.origin);
          lookup.searchParams.set('view', 'jk-gift-card-data');
          lookup.searchParams.set('option_values', matches[0].id);
          const selected = await this.fetchJson(lookup, { headers:{ 'Accept':'text/html' } });
          if (String(selected.product_id) !== this.dataset.productId || selected.gift_card !== true || selected.currency !== 'EUR' || !selected.variant?.available || selected.variant.price !== amount * 100) throw new Error(this.copy.unavailable);
          const properties = {};
          for (const [name, value] of new FormData(this.form)) {
            const match = /^properties\[(.+)\]$/.exec(name);
            if (match && match[1] !== '_jk_gift_request' && value) properties[match[1]] = value;
          }
          const payloadKey = JSON.stringify([this.dataset.productId, amount, properties]);
          const bytes = new TextEncoder().encode(payloadKey);
          const digest = await crypto.subtle.digest('SHA-256', bytes);
          const fingerprint = Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('');
          storageKey = 'jk-gift:' + fingerprint;
          let request = sessionStorage.getItem(storageKey);
          if (!request) { request = crypto.randomUUID(); sessionStorage.setItem(storageKey, request); }
          properties._jk_gift_request = request;
          const root = window.Shopify?.routes?.root || '/';
          const cart = await this.fetchJson(root + 'cart.js');
          const sameGift = cart.items.find(item => item.properties?._jk_gift_request === request);
          if (sameGift) {
            if (sameGift.quantity !== 1 || sameGift.original_price !== amount * 100) throw new Error(this.copy.uncertain);
            location.assign(root + 'cart');
            return;
          }
          if (sessionStorage.getItem(storageKey + ':pending')) throw new Error(this.copy.uncertain);
          sessionStorage.setItem(storageKey + ':pending', 'true');
          requestAttempted = true;
          const added = await this.fetchJson(root + 'cart/add.js', {
            method:'POST', headers:{ 'Content-Type':'application/json' },
            body:JSON.stringify({ items:[{ id:selected.variant.id, quantity:1, properties }] })
          });
          const item = added.items?.[0];
          if (!item || added.items.length !== 1 || String(item.variant_id) !== String(selected.variant.id) || item.quantity !== 1 || item.original_price !== amount * 100) throw new Error(this.copy.uncertain);
          sessionStorage.removeItem(storageKey + ':pending');
          this.button.querySelector('span').textContent = this.copy.added;
          location.assign(root + 'cart');
        } catch (error) {
          this.error(requestAttempted ? this.copy.uncertain : (error.message || this.copy.network));
          this.button.querySelector('span').textContent = initialButtonText;
          this.busy = false;
          this.form.inert = false;
          this.button.disabled = false;
        }
      }
    }
    customElements.define('jk-gift-card', JkGiftCard);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-stock-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('jk-product-stock')) {
  class JKProductStock extends HTMLElement {
    static selectRows(rows, productId, variantId, singleVariant) {
      const id = value => String(value ?? '').split('/').pop();
      const rowId = row => id(row.shopifyVariantId ?? row.variantId ?? row.shopifyIdNumeric ?? row.shopifyId);
      const selected = rows.filter(row => rowId(row) === id(variantId));
      if (selected.length || !singleVariant) return selected;
      return rows.filter(row => rowId(row) === id(productId));
    }

    static summarize(rows) {
      const result = { tartu: { quantity: 0, known: false }, tallinn: { quantity: 0, known: false }, supplier: { quantity: 0, known: false } };
      const locations = new Set();
      rows.forEach(row => {
        const location = row.location || {};
        const name = `${location.code || ''} ${location.name || location.title || location.displayName || location.locationName || location.warehouseName || ''}`.toUpperCase();
        const key = name.includes('TARTU') ? 'tartu' : name.includes('TALLINN') ? 'tallinn' : 'supplier';
        locations.add(key);
        // The warehouse feed uses null for a location without stock, as in the original block.
        const value = row.stockLevel === null ? 0 : row.stockLevel;
        if (value === undefined || typeof value === 'boolean' || String(value).trim() === '') return;
        const quantity = Number(value);
        if (!Number.isFinite(quantity)) return;
        result[key].known = true;
        result[key].quantity += Math.max(0, quantity);
      });
      // A successful selected-product/variant response can omit an empty warehouse.
      Object.entries(result).forEach(([key, location]) => {
        if (rows.length && !locations.has(key)) location.known = true;
      });
      return result;
    }

    connectedCallback() {
      this.productInfo = this.closest('product-info');
      this.labels = JSON.parse(this.querySelector('[data-stock-translations]').textContent);
      this.variants = JSON.parse(this.querySelector('[data-stock-variants]').textContent);
      this.onChange = event => {
        if (event.target.matches('.product-variant-id')) this.render();
      };
      this.productInfo?.addEventListener('change', this.onChange);
      const pubsub = window.FoxTheme?.pubsub;
      if (pubsub?.PUB_SUB_EVENTS?.variantChange) {
        this.unsubscribe = pubsub.subscribe(pubsub.PUB_SUB_EVENTS.variantChange, event => {
          if (event.data?.sectionId === this.productInfo?.dataset.section) this.render();
        });
      }
      this.controller = new AbortController();
      this.load();
    }

    disconnectedCallback() {
      this.productInfo?.removeEventListener('change', this.onChange);
      this.unsubscribe?.();
      this.controller?.abort();
    }

    async load() {
      try {
        const base = window.appConfig?.apiBaseUrl || 'https://gate.jahikala.ee';
        const response = await fetch(`${base}/stock/shopify/${this.dataset.productId}`, {
          credentials: 'include', headers: { Accept: 'application/json' }, signal: this.controller.signal
        });
        if (!response.ok) throw new Error('Stock unavailable');
        const data = await response.json();
        if (data.success === false || !Array.isArray(data.responseObject)) throw new Error('Stock unavailable');
        this.rows = data.responseObject;
        this.failed = false;
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.failed = true;
      }
      if (this.isConnected) this.render();
    }

    render() {
      const input = this.productInfo?.querySelector('.product-variant-id');
      const variantId = input ? input.value : this.dataset.variantId;
      const variant = this.variants.find(item => String(item.id) === String(variantId));
      const selected = JKProductStock.selectRows(this.rows || [], this.dataset.productId, variantId, this.dataset.singleVariant === 'true');
      const stock = JKProductStock.summarize(selected);
      const local = stock.tartu.quantity + stock.tallinn.quantity;
      const supplier = stock.supplier.quantity;
      let summary = this.failed ? 'error' : 'unknown';
      if (local > 0) summary = 'local';
      else if (supplier > 0) summary = 'supplier';
      if (variant?.available === false) summary = 'sold_out';
      else if (!variant) summary = 'choose';
      this.dataset.stockState = summary;
      this.querySelector('[data-stock-summary]').textContent = this.labels[summary];
      const delivery = this.querySelector('[data-stock-delivery]');
      delivery.hidden = !variant?.available || !(local > 0 || supplier > 0);
      delivery.textContent = local > 0 ? this.labels.local_delivery : this.labels.supplier_delivery;
      this.querySelector('[data-stock-pickup]').hidden = !variant?.available || stock.tartu.quantity <= 0;
      const list = this.querySelector('[data-stock-locations]');
      list.replaceChildren();
      const cap = Math.max(1, Number(this.dataset.cap) || 5);
      Object.entries(stock).forEach(([key, location]) => {
        const item = document.createElement('li');
        const content = document.createElement('div');
        content.className = 'jk-product-stock__location';
        const label = document.createElement('span');
        const value = document.createElement('span');
        value.className = 'jk-product-stock__value';
        label.textContent = this.labels[key === 'supplier' ? 'supplier_location' : key];
        value.textContent = location.known ? (location.quantity > cap ? `${cap}+` : String(location.quantity)) : this.labels.unknown_quantity;
        content.append(label);
        if (key === 'supplier') {
          const leadtime = document.createElement('span');
          leadtime.className = 'jk-product-stock__leadtime';
          leadtime.textContent = this.labels.supplier_leadtime;
          content.append(leadtime);
        }
        item.append(content, value);
        list.append(item);
      });
      this.querySelector('[data-stock-details]').hidden = !variant || !selected.length;
    }
  }
  customElements.define('jk-product-stock', JKProductStock);
}
  } catch(e) { console.error(e); }
})();

})();
